import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const CartCircleCheck = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 640 512"
      {...props}
    >
      <path
        opacity={0.3}
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M0 8C0-5.3 10.7-16 24-16l45.3 0c27.1 0 50.3 19.4 55.1 46l.4 2 412.7 0c20 0 35.1 18.2 31.4 37.9L542 213.5c-14.7-3.6-30.1-5.5-46-5.5-64.2 0-121.1 31.5-156 80l-168.7 0 5.1 28.3c2.1 11.4 12 19.7 23.6 19.7l114.9 0c-5.4 15.2-8.9 31.3-10.3 48l-104.6 0c-34.8 0-64.6-24.9-70.8-59.1L77.2 38.6c-.7-3.8-4-6.6-7.9-6.6L24 32C10.7 32 0 21.3 0 8zM256 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
      />
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm60.9-182.6l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5s8.7 15.2 3.5 22.3z"
      />
    </SvgIcon>
  );
};
